function ExclusiveTag() {
    return <p className='tag exclusive'><i class="fa-regular fa-heart"></i> Friends Only</p>;
  }

export default ExclusiveTag;